import { http } from './http';

export interface PagedResult<T> {
  items: T[];
  continuationToken: string | null;
}

export async function getDocumentsByFolder<T = any>(drawerId: number, folderId: number, q: string, take = 100, continuationToken?: string | null): Promise<PagedResult<T>> {
  const url = `/api/document/byfolder?drawerId=${drawerId}&folderId=${folderId}`
    + (q ? `&q=${encodeURIComponent(q)}` : '')
    + `&take=${take}`
    + (continuationToken ? `&continuationToken=${encodeURIComponent(continuationToken)}` : '');

  const data: any = await http<any>(url);
  const items = (data?.Values ?? data?.values ?? []) as T[];
  const token = (data?.ContinuationToken ?? data?.continuationToken ?? null) as string | null;
  return { items, continuationToken: token };
}
